import { call } from '../core'
import { RequestPinAuthAction } from './requestPinAuth'

export interface IChangeDebitCardPincodeParams {
  debitCardNo: string
}

export interface IChangeDebitCardPincodeInfo {
  action: RequestPinAuthAction
  response: string // JSON string
}

export interface IChangeDebitCardPincodeResult {
  result: IChangeDebitCardPincodeInfo | null
}

export function changeDebitCardPincode(
  params: IChangeDebitCardPincodeParams,
): Promise<IChangeDebitCardPincodeResult | Error> {
  return call('finChangeDebitCardPincode', params)
}
